import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/employee-management-system/payroll-integration/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "payroll-integration" entry is kept); the seo block below is a fallback.

export const payrollIntegration: ContentPage = {
  slug: "employee-management-system/payroll-integration",
  template: "hrmsFeature",
  seo: {
    title: "Payroll Integration System for Accurate Salary Processing",
    description: "Automate payroll based on attendance, performance, and tax rules for accurate, timely payments, with built-in compliance management for smooth processing.",
    keywords: [
      "payroll integration software",
      "employee payroll management",
      "payroll automation",
      "attendance-based payroll",
      "tax and deduction management",
      "payroll compliance system.",
    ],
    ogImage: "/assets/data/seoimages/payroll-integration.webp",
  },
  leaf: {
    hero: {
      caption: "Payroll Integration",
      title: "Seamless Payroll Integration for Accurate and Timely Payments",
      description: "Automate payroll calculations based on attendance, overtime, and performance data, ensuring precise payments and compliance with labor regulations.",
      h1: "caption",
    },
    split: {
      title: "Automate Payroll with Real-Time Data Integration",
      bullets: [
        { title: "Attendance-Based Payroll", description: "Calculate salaries based on attendance records." },
        { title: "Tax and Deductions Management", description: "Manage tax withholdings and deductions." },
        { title: "Custom Salary Structures", description: "Define salary components and allowances." },
        { title: "Compliance Management", description: "Ensure payroll compliance with local laws." },
      ],
      image: "/assets/images/img/product/hrms/employeems/payroll_integration_image.webp",
      imageAlt: "payroll-integration",
    },
    cardsHeading: {
      title: "Key Features of Employee Management System",
      description: "Optimize Employee management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Attendance Tracking",
        href: "/hrms-software/employee-management-system/attendance-tracking",
        description: "Track and monitor employee attendance with real-time clock-in/out, ensuring precise records for improved productivity and payroll accuracy.",
        image: "/assets/images/img/product/hrms/employeems/attendance_tracking_images.webp",
        imageAlt: "attendance_tracking_key_features",
      },
      {
        title: "Leave Management",
        href: "/hrms-software/employee-management-system/leave-management",
        description: "Simplify leave requests and approvals with automated workflows, ensuring smooth operations and minimal disruptions.",
        image: "/assets/images/img/product/hrms/employeems/leave_management.webp",
        imageAlt: "leave_management",
      },
      {
        title: "Employee Directory",
        href: "/hrms-software/employee-management-system/employee-directory",
        description: "Easily manage employee profiles, personal details, roles, and contact information in a secure and centralized directory for streamlined operations.",
        image: "/assets/images/img/product/hrms/employeems/employee_directory_image.webp",
        imageAlt: "employee_directory_key_features",
      },
      {
        title: "Performance Review",
        href: "/hrms-software/employee-management-system/performance-review",
        description: "Track employee performance, set KPIs, and provide feedback with structured review processes for better productivity and growth.",
        image: "/assets/images/img/product/hrms/employeems/performance_review.webp",
        imageAlt: "performance_review",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Ensure Accurate Payments with Payroll Automation!",
    relatedBlogs: "static",
    metaKey: "payroll-integration",
  },
  sections: [],
};
